/* DSD notification bell route entry. Unread count is supplied by LaunchSocialActivation. */
(function(){
  'use strict';
  var VERSION = 'p11dz397-notification-bell-active-entry';

  function claim(surface, meta){
    try {
      var r = window.DSDRegistry || window.DSDRuntimeRegistry;
      if (r && typeof r.claim === 'function') r.claim(surface, 'NotificationBell', meta || {});
    } catch(e) {}
  }

  function setCount(count){
    var value = Math.max(0, Number(count || 0));
    document.querySelectorAll('[data-dsd-notification-unread-count]').forEach(function(node){
      node.textContent = String(value);
      node.hidden = value === 0;
      node.setAttribute('aria-label', value + ' unread notifications');
    });
  }

  window.addEventListener('dsd:launch-social:notifications', function(event){
    setCount(event.detail && event.detail.unread);
  });

  document.querySelectorAll('[data-dsd-notification-bell], .dsd-notification-bell-p11dz322').forEach(function(bell){
    bell.setAttribute('data-dsd-owner', 'NotificationBell');
    bell.setAttribute('data-dsd-notification-bell', 'p11dz397');
  });

  window.DSDNotificationBell322 = {
    version: VERSION,
    status: 'ACTIVE_ROUTE_ENTRY_FIREBASE_COUNT_READY',
    owner: 'NotificationBell',
    route: '/pages/notifications',
    firebaseCountSource: 'LaunchSocialActivation'
  };

  claim('notification-bell:header-entry', {
    version: VERSION,
    route: '/pages/notifications',
    singleOwner: true,
    firebaseCountSource: 'LaunchSocialActivation'
  });
})();
